import CRUDService from "../services/base/CRUDService";

export default class ProductTypeService extends CRUDService {

  static ALL_URL = 'ton/v1/product-types/';

  getBaseURL() {
    return 'ton/v1/product-types/';
  }

  findAllParams() {
    return this.getHttpRequest().get(`${ProductTypeService.ALL_URL}params`);
  }
}



// WEBPACK FOOTER //
// ./src/productType/ProductTypeService.js